export const URL_MAPA_PREDICCIO = `pronostic/catalunya/catalunya-{DATE}.json`;
export const URL_PREDICCIO_COMARQUES = `pronostic/comarcal/comarcal-{DATE}.json`;
export const URL_RADAR = `referencia/tiles/dates-tiles-CAPPI_0m.json`;
export const URL_MUNICIPIS = `referencia/municipis/municipis.json`;
export const URL_AVISOS = `pronostic/smp/episodisOberts/avisos-episodis-oberts-{DATE}.json`;
export const URL_EST_CEL = `models/postProcessament/variables/est_cel/intervals/{INTERVAL}/est_cel-{DAY}_{INTERVAL}h.json`;
export const URL_TEMP = `models/postProcessament/variables/temperature/intervals/{INTERVAL}/temperature-{DAY}_{INTERVAL}h.json`;
export const URL_TEMP_MAX = `models/postProcessament/variables/temperature_max/intervals/{INTERVAL}/temperature_max-{DAY}_{INTERVAL}h.json`;
export const URL_TEMP_MIN = `models/postProcessament/variables/temperature_min/intervals/{INTERVAL}/temperature_min-{DAY}_{INTERVAL}h.json`;
export const URL_TEMP_XAF = `models/postProcessament/variables/hi/intervals/{INTERVAL}/hi-{DAY}_{INTERVAL}h.json`;
export const URL_PREC_ACU = `models/postProcessament/variables/prec_acum/intervals/{INTERVAL}/prec_acum-{DAY}_{INTERVAL}h.json`;
export const URL_PROB_PREC = `models/postProcessament/variables/prob_prec/intervals/{INTERVAL}/prob_prec-{DAY}_{INTERVAL}h.json`;
export const URL_HUM_REL = `models/postProcessament/variables/rh/intervals/{INTERVAL}/rh-{DAY}_{INTERVAL}h.json`;
export const URL_VENT_DIR = `models/postProcessament/variables/wdir/intervals/{INTERVAL}/wdir-{DAY}_{INTERVAL}h.json`;
export const URL_VENT_VELO = `models/postProcessament/variables/wspd/intervals/{INTERVAL}/wspd-{DAY}_{INTERVAL}h.json`;

const topojsonURL = `https://static-m.meteo.cat/assets-w3/json/topojson/`;
export const limitsCat = `${topojsonURL}limits.json`;
export const limitsComarques = `${topojsonURL}limits_comarques.json`;
export const limitsComarquesAmbMar = `${topojsonURL}comarquesAmbMar.json`;
export const baseTiles = `https://static-m.meteo.cat/tiles/fons/GoogleMapsCompatible/`;
export const radarTiles = `https://static-m.meteo.cat/tiles/radar/`;
export const suffixUrlTiles = `{z}/000/000/{x}/000/000/{y}.png`;

export const links = {
    baseMeteo: 'https://www.meteo.cat',
    baseMeteoEn: 'https://en.meteocat.gencat.cat',
    baseMeteoEs: 'https://es.meteocat.gencat.cat',
    baseGencat: 'https://web.gencat.cat',
    footerAvisLegal: '/wpweb/avis-legal/',
    footerAccessibilitat: '/ca/ajuda/accessibilitat',
    footerContacte: '/wpweb/contacte/',
    footerSobreMeteo: '/wpweb/sobre-meteocat/',
    footerSobreGencat: '/ca/ajuda/sobre_gencat/',
    urlISO:
        'http://static-m.meteo.cat/content/files/1903_20_ISO_9001_15_CAT_TRANSFER.pdf',
    avisosPrediccioGral: '/prediccio/general',
    radarObservacions: '/observacions/radar',
    navDataUrlEn: '/xema?lang=en',
    navPredictionUrlEn: '/?lang=en',
    navRadarUrlEn: '/radar?lang=en',
    navDataUrlEs: '/xema?lang=es',
    navPredictionUrlEs: '/?lang=es',
    navRadarUrlEs: '/radar?lang=es',
    navDataUrlCa: '/observacions/xema',
    navPredictionUrlCa: '/prediccio/general',
    navRadarUrlCa: '/observacions/radar',
};



// WEBPACK FOOTER //
// ./src/utils/urls.js